import React from 'react';
import moment from 'moment-timezone';

import { ReactComponent as CircleExclamation } from '../../../assets/icons/CircleExclamation.svg';

import Tooltip from '../../Tooltip/Tooltip';
import HorizontalCardField from '../HorizontalCardField/HorizontalCardField';

import classes from './FieldExpiring.module.scss';

const today = moment();

const FieldExpiring = ({ className, expiring }) => {
  const getExpiringFieldValue = expiringDate =>
    !!expiringDate && moment(expiringDate).isValid() ? moment(expiringDate).format('DD/MM/YYYY') : '';

  let expiringClass = classes['not-expired'];
  let ExpirationIcon = null;
  let popoverClass = null;
  let popoverText = null;
  if (today.isAfter(expiring, 'day')) {
    expiringClass = classes['expired'];
    //ExpirationIcon = helpRed;
    ExpirationIcon = CircleExclamation;
    popoverClass = classes['popover-expired'];
    popoverText = 'Tu cuenta de cobro ya se venció';
  } else if (moment(expiring).diff(today, 'day') < 2) {
    expiringClass = classes['soon-expired'];
    ExpirationIcon = CircleExclamation;
    popoverClass = classes['popover-soon-expired'];
    popoverText = 'Tu cuenta de cobro se vencerá pronto';
  }

  const ExpiringPopoverContent = <span className={`${popoverClass} semibold-14`}>{popoverText}</span>;

  return (
    <HorizontalCardField className={className} classChildren={classes.content} title='PRÓX. VENCIMIENTO'>
      <span className={`${expiringClass} semibold-16`}>{getExpiringFieldValue(expiring)}</span>
      {ExpirationIcon && (
        <Tooltip key='popover' content={ExpiringPopoverContent} position='bottom' type='error'>
          <ExpirationIcon />
        </Tooltip>
      )}
    </HorizontalCardField>
  );
};

export default FieldExpiring;
